import HeaderRequest from '../lib/common/header-request';
import {
    ROUTE_ME,
    ROUTE_TOKEN,
    ROUTE_LOGIN
} from '../constants/routes/routes-service';
// import { SERVICE_ACTIONS } from '../constants/actions';
import CustomUrl from '../lib/common/custom-url';

export default class AuthApi {
    constructor(action$, store, deps) {
        this.action$ = action$;
        this.store = store;
        this.deps = deps;
    }

    login = payload => this.deps.ajax
        .post(CustomUrl.getURL(ROUTE_LOGIN, {}, true, process.env.REACT_APP_AUTH_PREFIX), payload, HeaderRequest.getPublicRequestHeader());

    me = () => this.deps.ajax
        .getJSON(CustomUrl.getURL(ROUTE_ME, {}, true, process.env.REACT_APP_AUTH_PREFIX), HeaderRequest.getRequestHeader());

    logout = () => this.deps.ajax
        .delete(CustomUrl.getURL(ROUTE_TOKEN, {}), HeaderRequest.getRequestHeader());

    token = () => this.deps.ajax
        .getJSON(CustomUrl.getURL(ROUTE_TOKEN, {}), HeaderRequest.getRequestHeader());
}

/*

    function login (payload) {
        payload = {
            usuario: '',
            password: '',
        }
    }





*/


// WEBPACK FOOTER //
// ./src/api/auth.js